{
  "colorInputLabel": "{label}，{channelLabel}",
  "colorNameAndValue": "{name}：{value}",
  "colorPicker": "檢色器",
  "twoDimensionalSlider": "2D 滑桿",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
